export default __webpack_public_path__ + "static/taskdeploy4-896b3759db5edfd6df39e97db2255235.png";